
import {Radar} from 'vue-chartjs';
import {defineComponent, PropType} from "vue";
import {
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend
} from 'chart.js'
import ChartJS from 'chart.js/auto';
ChartJS.register(CategoryScale, LinearScale, Title, Tooltip, Legend)

export default defineComponent({
  name: 'TeethRadarChart',
  components: {Radar},
  props:{
    currentData: {type: Array as PropType<number[]>, required: true},
    currentLabel: {type: String, required: true},
    currentBorderColor: {type: String, required: true},
  },
  data(){
    return{
      showChart: true,
      data:{
        labels: [
          '歯石',
          '歯周病',
          'CPITN',
          '欠損',
          'WSD',
          'う蝕歯',
        ],
        datasets: [{
          label: '平均値',
          data: [50, 50, 50, 50, 50, 50],
          fill: true,
          backgroundColor: 'rgba(255, 99, 132, 0.2)',
          borderColor: 'rgb(255, 99, 132)',
          borderWidth:0,
          pointBackgroundColor: 'rgb(255, 99, 132)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgb(255, 99, 132)',
          pointStyle: false
        },
          {
          label: this.currentLabel,
          data: this.currentData,
          fill: false,
          backgroundColor: this.currentBorderColor,
          borderColor: this.currentBorderColor,
          pointBackgroundColor: this.currentBorderColor,
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: this.currentBorderColor,
        },
        ]
      },
      options: {
        responsive: true,
        elements: {
          line: {
            borderWidth: 3
          },
          point:{
            //pointStyle: false
          }
        },
        scales: {
          r: {
            max: 70,
            min: 30,
            ticks: {
              display: false,
              stepSize: 10
            }
          }
        }
      }
    }
  },
  created() {
//
  },
  watch: {
    currentData(newData) {
      this.showChart = false
      setTimeout(()=>{
            this.showChart = true
      }, 100)
      this.data.datasets[1].data = this.currentData
      console.log(this.currentLabel + JSON.stringify(this.currentData))
      console.log('>>>>>>>>>>>>>>data changed>>>>>')
    }
  }
});
